import { useWishes } from '../../../../../redux/reducer/content';
import { giftShowAnimation } from '../../utils/giftShowAnimation';

export default function useItemData({ type, index, author, wishId, authorUsername, preview_image, elf }) {
  const { images } = useWishes();
  const domElementsRef = giftShowAnimation({ index });

  const wishImage = images.find(({ id }) => id === wishId);

  return {
    wishImage,
    elfImage: wishImage?.[`elf${elf}`],
    senderId: { wish: `id${author}` }[type],
    titleValue: { wish: authorUsername }[type],
    preview: { cloth: [preview_image], wish: [wishImage?.[`elf${elf}`]] }[type],
    domElementsRef,
  };
}
